import React from "react";
import { makeStyles } from "@material-ui/core";
import Info from "./info/index";
import Card from "./cradList";
import { actionTypes as actionOms } from "./../../redux/oms/customer_select_get_kyc_profile";
import { useDispatch } from "react-redux";

let useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 250,
    width: "90%",
    margin: "auto",
    marginTop: 15,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    "@media(max-width : 1185px)": {
      width: "98%",
    },
    "@media(max-width : 950px)": {
      flexDirection: "column-reverse",
    },

    // flexWrap:'wrap'
  },
  textBold: {
    display: "inline-block",
    color: "#050A2A",
    fontSize: 16,
    fontWeight: "bold",
    paddingRight: "6px",
    whiteSpace: "nowrap",
    // marginBottom:0,
  },
  gridInfo: {
    width: "28%",
    minWidth: 400,
    "@media(max-width : 1185px)": {
      minWidth: 350,
    },
    "@media(max-width : 1181px)": {
      minWidth: 250,
      width: "32%",
    },
    "@media(max-width : 950px)": {
      minWidth: 250,
      width: "100%",
    },
  },
  gridList: {
    width: "68%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    "@media(max-width : 950px)": {
      width: "100%",
      flexWrap: "wrap",
    },
  },
  subFooter: {
    position: "relative",
  },
  subGrid: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    zIndex: 2,
    width: "90%",
    margin: "auto",
    "@media(max-width : 500px)": {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  line: {
    position: "absolute",
    width: "90%",
    margin: "auto",
    height: 10,
    top: 25,
    left: "50%",
    transform: " translate(-50%, -50%)",
  },
  title: {
    fontSize: 14,
    color: "#AAAAAA",
    backgroundColor: "white",
    padding: "10px 5px",
  },
  wrapEnamad: {
    "@media(max-width : 500px)": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
    },
  },
  gridEnamad: {
    padding: "10px",
    backgroundColor: "white",
    width: 90,
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 13,
    top: "-36px",
    position: "relative",
    "@media(max-width : 500px)": {
      top: "0px",
    },
    "& img": {
      width: "100%",
    },
    // border:'1px solid rgba(0,0,0,0.3)'
  },
}));

export default function Index() {
  let dispatch = useDispatch();

  const handelCHnageOms = (data) => {
    dispatch({ type: actionOms.clubmemberCustomerKycOmsFlag, payload: true });
  };

  let classes = useStyles();
  const state = [
    {
      title: "دسترسی سریع",
      list: [
        {
          title: "سامانه معاملاتی اکسیر",
          link: "https://poyan.exirbroker.ir",
        },
        {
          title: "سامانه معاملاتی تدبیر",
          link: "https://online.pouyanbroker.ir/",
        },
        {
          title: "گواهی سپرده مشتقه کالایی",
          link: "https://coinonline.pouyanbroker.ir",
        },
        {
          title: "سامانه کمان",
          link: "https://kaman.pouyanbroker.ir",
        },
        {
          title: "مای پویان (مرکز خدمات)",
          link: "https://my.pouyanbroker.ir",
        },
        {
          title: "ثبت نام غیرحضوری",
          link: "https://reg.pouyanbroker.ir",
        },
        {
          title: "ثبت شکایات",
          link: "https://my.pouyanbroker.ir/dashboard?open=complaint",
        },
      ],
    },
    {
      title: "سرمایه‌گذاری",
      list: [
        {
          title: "شروع سرمایه‌گذاری",
          link: "/Investment",
        },
        {
          title: "سوالات متداول",
          link: "/faq",
        },
        {
          title: "دستورالعمل ها و فایل آموزشی",
          link: "/Trades",
        },
        {
          title: "تغییر پنل معاملاتی",
          link: "",
          action: (data) => handelCHnageOms(data),
        },
      ],
    },

    {
      title: "بازارها",
      list: [
        {
          title: "دریافت کد بورسی و سجام",
          link: "https://reg.pouyanbroker.ir/auth/phone",
        },
        {
          title: "فایل‌های آموزشی",
          link: "/education",
        },
        {
          title: "خرید خودرو در بورس",
          link: "https://pouyan.ebgo.ir/StockCode",
        },
      ],
    },
    {
      title: "درباره پویان",
      list: [
        {
          title: " مدیران",
          link: "/MangementUsers",
        },
        {
          title: "شعب و دفاتر",
          link: "/Shoab",
        },
        {
          title: "شماره حساب‌ها",
          link: "/AcountNumber",
        },
        {
          title: "درباره پویان",
          link: "/AboutUs",
        },
        {
          title: "ارتباط با ما",
          link: "/ContactUs",
        },
      ],
    },
  ];
  return (
    <>
      <div className={classes["root"]}>
        <div className={classes["gridInfo"]}>
          <Info BoldText={classes["textBold"]} />
        </div>
        <div className={classes["gridList"]}>
          <Card data={state[0]} BoldText={classes["textBold"]} />
          <Card data={state[1]} BoldText={classes["textBold"]} />
          <Card data={state[2]} BoldText={classes["textBold"]} />
          <Card data={state[3]} BoldText={classes["textBold"]} />
        </div>
      </div>
      <div className={classes["subFooter"]}>
        <div className={classes["subGrid"]}>
          <div>
            <p className={classes["title"]}>
              کلیه حقوق این سایت متعلق به شرکت کارگزاری پویان است.
            </p>
          </div>
          <div className={classes["wrapEnamad"]}>
            <div className={classes["gridEnamad"]}>
              <a
                rel="origin"
                target={"_blank"}
                href={
                  "https://trustseal.enamad.ir/?id=280030&Code=o08KbJqZ135Q2ZR1VlYt"
                }
              >
                <img
                  referrerPolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=280030&Code=o08KbJqZ135Q2ZR1VlYt"
                  alt=""
                  style={{ cursor: "pointer" }}
                />
              </a>
            </div>
          </div>
        </div>
        <hr className={classes["line"]} />
      </div>
    </>
  );
}
